import React from 'react';
import { FilterableMultiSelect } from '@carbon/react';

export default function MultiSelectDropdownControl(props) {
  return <FilterableMultiSelect {...props} />;
}
